var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-header-top-container" }, [
          _c("div", { staticClass: "page-name" }, [
            _vm._v("Draggable Benefits")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 pull-right" },
            [
              _c("v-select", {
                attrs: {
                  name: "locationId",
                  id: "locationId",
                  label: "text",
                  clearable: false,
                  searchable: false,
                  filterable: false,
                  options: _vm.locationArr,
                  placeholder: "Select State"
                },
                model: {
                  value: _vm.locationId,
                  callback: function($$v) {
                    _vm.locationId = $$v
                  },
                  expression: "locationId"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("form", { attrs: { id: "benefitForm" } }, [
            _c(
              "div",
              {},
              [
                _c(
                  "draggable",
                  {
                    staticClass: "drag-view",
                    on: {
                      change: function($event) {
                        return _vm.changePosition()
                      }
                    },
                    model: {
                      value: _vm.draggableBenefitsList,
                      callback: function($$v) {
                        _vm.draggableBenefitsList = $$v
                      },
                      expression: "draggableBenefitsList"
                    }
                  },
                  [
                    _vm._l(_vm.draggableBenefitsList, function(text, index) {
                      return [
                        _c(
                          "div",
                          {
                            key: index,
                            staticClass:
                              "col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-20"
                          },
                          [
                            _c("div", { staticClass: "card" }, [
                              _c("div", { staticClass: "card-body" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-lg-12 col-md-12 col-sm-12 col-xs-12"
                                  },
                                  [
                                    _c(
                                      "h2",
                                      {
                                        staticClass:
                                          "text-muted display-4 text-danger"
                                      },
                                      [
                                        _c("strong", [
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                _vm._s(text.type_name) +
                                                  " - " +
                                                  _vm._s(text.provider_name)
                                              )
                                            ]
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-lg-6 col-md-6 col-sm-12 col-xs-12"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _vm._v(
                                              "\n                                                    " +
                                                _vm._s(text.location_name) +
                                                "\n                                                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "form-group",
                                          domProps: {
                                            innerHTML: _vm._s(text.phone)
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c("p", {
                                              directives: [
                                                {
                                                  name: "linkified",
                                                  rawName:
                                                    "v-linkified:options",
                                                  value: {
                                                    className: "internal-link"
                                                  },
                                                  expression:
                                                    "{ className: 'internal-link' }",
                                                  arg: "options"
                                                },
                                                {
                                                  name: "linkified",
                                                  rawName: "v-linkified"
                                                }
                                              ],
                                              domProps: {
                                                innerHTML: _vm._s(text.url)
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" })
                              ])
                            ])
                          ]
                        )
                      ]
                    })
                  ],
                  2
                )
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-87d2daba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87d2daba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/benefits/ListDraggableBenefits.vue
// module id = null
// module chunks = 